import { text } from '../text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faSquareEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
type Props = {
    review: any;
    isLast: boolean;
};
export const LocationItem: React.FC<Props> = ({ review, isLast }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                marginBottom: isLast ? 0 : 20,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: '#F9FAFC',
                borderRadius: 6,
                padding: 15,
                border: '1px solid ##EFEEFB',
            }}
        >
            <div style={{display:"flex",  width: 150, justifyContent: 'center', alignItems: 'center' }}>
                <FontAwesomeIcon icon={faLocationDot} style={{ color: '#677EDE', width: 50, height: 50, marginRight: 20 }} />
            </div>

            <div style={{ width: '100%', borderLeft: "2px dashed black" }}>
                <text.H5
                    style={{ marginBottom: 0, marginLeft: 25, color: "#7065F0", }}
                    numberOfLines={1}
                >
                    Northern Packers
                </text.H5>
                <text.H3 style={{ marginLeft: 25, lineHeight: 1.8 }}>50 % off</text.H3>
                <text.T14 style={{ marginLeft: 25, lineHeight: 1 }}>On your first shifting</text.T14>
            </div>

        </div>
    );
};
